const domainQrScannerEn = {
  error: {
    title: "Camera Error",
    message: "Cannot access camera.\nPlease check your browser settings.",
    notAllowed: "Camera access denied",
    notFound: "Camera not found",
    notReadable: "Camera is being used by another application",
    unknown: "An unknown error occurred",
    invalidQrData: "Invalid QR code data",
    dangerousQr: "Potentially dangerous QR code detected",
    privateBrowsing: "Camera is not available in private browsing mode",
    insecureContext: "HTTPS is required. Please access via secure connection",
    unsupportedBrowser: "Your browser does not support camera access",
    deviceBusy: "Camera device is busy",
    constraintNotSatisfied: "Camera configuration requirements not met",
    timeout: "Camera startup timed out",
  },
  loading: {
    message: "Starting camera...",
  },
  guide: {
    message: "Align QR code within the frame",
  },
  paused: {
    message: "Scan paused",
  },
  aria: {
    scannerLabel: "QR code scanner",
    cameraStarting: "Camera starting",
    cameraError: "Camera error occurred",
    scanPaused: "Scan paused",
    scanReady: "Scan ready",
  },
  retry: {
    buttonText: "Retry",
  },
};

export default domainQrScannerEn;
